var utils = require('./tripletrax.utils.js');
var nestable = require('./tripletrax.nestable.js');
var validator = require('./tripletrax.validator.js');
var patients = require('./tripletrax.patients.js');
var views = require('./tripletrax.views.js');
var ajax = require('./tripletrax.ajax.js');
var initialize = require('./tripletrax.initialize.js');
var access = require('./tripletrax.access.js');
var reports = require('./tripletrax.reports.js');

function saveChanges(e) {

    return $.Deferred(function (defer) {
        var el = e.target;
        //console.log('saveChanges');
        //console.log(el);
        //console.log(window.location.pathname);
        if (/\/admin/.test(window.location.pathname)) {

            if (!utils.GLOBALS.programmaticClick) {
                var form = null;
                var content_detail = document.getElementById("content-detail-modal");
                if (utils.isUndefined(content_detail) || (!utils.isUndefined(content_detail) && !content_detail.contains(el))) {

                    content_detail = document.getElementById("content-modal");

                    if (utils.isUndefined(content_detail) || (!utils.isUndefined(content_detail) && !content_detail.contains(el))) {
                        content_detail = document.getElementById("content-sub-detail");

                        if (utils.isUndefined(content_detail) || (!utils.isUndefined(content_detail) && !content_detail.contains(el))) {
                            content_detail = document.getElementById("content-detail");
                        }
                    }

                    form = $(content_detail).find('.tt-check-changes-form');

                } else {
                    form = $(el).parents('.tt-content-dialog').find('.tt-check-changes-form');
                }

                //if (!utils.isUndefined(form)) {
                //  console.log(form);
                //  console.log(form.hasClass('dirty'));
                //}

                var elementIsOnForm = false;
                jQuery.each(form, function (i, singleForm) {
                    if ($(singleForm).parents('.widget-body').length > 0 && $(singleForm).parents('.widget-body')[0].contains(el)) {
                        elementIsOnForm = true;
                    }
                });

                if (!utils.isUndefined(form) && form.hasClass('dirty')
                    && ($(el).is('a,button,td,.dd-handle,.dd3-content') || $(el).parents('a,button,.tt-datatable td,.dd-handle,.dd3-content').length)
                    && (form.parents('.widget-body').length > 0 && !elementIsOnForm)
                    && !/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.btn-header').length && !$(el).parents('.ui-datepicker-calendar').length) {

                    //console.log("1");
                    var parents = $(el).parents('a,button,.tt-datatable td,.dd-handle');

                    var doSaveChanges = true;
                    // Falls gleiches nestable Element gelöscht oder verschoben wird, welches gerade gewählt ist nichts machen.
                    if ($(el).is('.tt-delete-nestable') || parents.hasClass('tt-delete-nestable') || $(el).is('.dd-handle') || parents.hasClass('dd-handle') && !($(el).is('.tt-add-nestable') || parents.hasClass('tt-add-nestable'))) {
                        if ($(el).parents('.tt-content').find('.tt-selected-id').val() === $(el).parents('.dd-item')[0].getAttribute('data-id')) {
                            doSaveChanges = false;
                        }
                    }
                    // Buttons zum Aus- Einklappen nicht berücksichtigen
                    if (doSaveChanges && $(el).is('button') && !utils.isUndefined($(el).data().action) && ($(el).data().action == 'collapse' || $(el).data().action == 'expand')) {
                        doSaveChanges = false;
                    }
                    // Löschen, Speichern und Tabelle weiter und zurück dürfen nicht berücksichtigt werden
                    if (doSaveChanges && (!(($(el).hasClass('tt-delete') && !$(el).hasClass('tt-delete-nestable')) || $(el).hasClass('tt-delete-value-nestable') || $(el).hasClass('tt-save') || $(el).hasClass('tt-save-sub-form') || $(el).hasClass('tt-datatable-previous') || $(el).hasClass('tt-datatable-next') || $(el).hasClass('ui-datepicker-next') || $(el).hasClass('ui-datepicker-prev') || $(el).hasClass('tt-doc-tab') || $(el).hasClass('tt-left-button-nestable') || $(el).hasClass('jarviswidget-toggle-btn')
                        || (parents.hasClass('tt-delete') && !parents.hasClass('tt-delete-nestable')) || parents.hasClass('tt-delete-value-nestable') || parents.hasClass('tt-save') || parents.hasClass('tt-save-sub-form') || parents.hasClass('tt-doc-tab') || parents.hasClass('tt-datatable-previous') || parents.hasClass('tt-datatable-next') || parents.hasClass('ui-datepicker-next') || parents.hasClass('ui-datepicker-prev') || parents.hasClass('tt-left-button-nestable') || parents.hasClass('jarviswidget-toggle-btn')))) {

                        //console.log("2");
                        e.stopPropagation();
                        e.preventDefault();

                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation txt-color-orangeDark'></i>  <span class='txt-color-orangeDark'><strong>" + Lang.get('tripletrax.unsaved_changes') + "</strong></span>",
                            content: Lang.get('tripletrax.save_changes'),
                            buttons: '[' + Lang.get('tripletrax.cancel') + '][' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                if (form.valid()) {
                                    var saveButton = form.parents('.tt-content-detail').find('.tt-save,.tt-save-value-modal,.tt-save-value-nestable');

                                    if (!saveButton.is('.tt-save-value-nestable') && !saveButton.is('.tt-save-value-modal')) {
                                        utils.updateGlobals('elementToClickAfterSave', el);
                                    }
                                    if ($(el).is('.tt-preview') || $(el).parents('a,button,.tt-datatable td,.dd-handle').hasClass('tt-preview')) {
                                        if (!utils.isUndefined($('.dd-list .dd-content-active'))) {
                                            utils.updateGlobals('elementToClickAfterSave', $('.dd-list .dd-content-active')[0]);
                                            utils.updateGlobals('secondElementToClickAfterSave', el);
                                        }
                                    }

                                    saveButton.click();

                                    if (saveButton.is('.tt-save-value-nestable') || saveButton.is('.tt-save-value-modal')) {
                                        nestable.clickElement(el, true);
                                    }
                                }
                            } else if (ButtonPressed === Lang.get('tripletrax.no')) {
                                // Neu hinzugefügtes Nestable Item wieder entfernen
                                //var dd_item = $(el).parents('.dd').find("[data-id='0']");
                                var dd_item = $('#content').find('.dd').find("[data-id='0']");
                                var clickElement = true;
                                if (dd_item.length) {
                                    if ($(el).parents("[data-id='0']").length) {
                                        clickElement = false;
                                    }
                                    var parent_item = dd_item.parent().parent();

                                    if (dd_item.parents('.dd-list')[0].children.length === 1) {
                                        dd_item.parents('.dd-list')[0].remove();
                                    }

                                    dd_item.remove();

                                    if (!utils.isUndefined(parent_item)) {
                                        nestable.unsetNestableParent(parent_item);
                                    }
                                }

                                form.validate().resetForm();
                                form.trigger('reinitialize.areYouSure');
                                if (clickElement) {
                                    nestable.clickElement(el, true);
                                    if ($(el).parent().hasClass('tt-preview') || $(el).is('.tt-preview')) {
                                        $('#content-detail').empty();
                                    }
                                } else {
                                    $('#content-detail').empty();
                                }
                            }
                        });
                    }
                } else {
                    if ((!/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.btn-header').length && !$(el).parents('.ui-datepicker-calendar').length && el.id !== 'hide-menu' && $(el).parents().id !== 'hide-menu' && (!utils.isUndefined(el.hash) && !/^#/.test(el.hash))
                        && (!utils.isUndefined($(el).parents('a,button,.tt-datatable td').hash) && !/^#/.test($(el).parents('a,button,.tt-datatable td').hash)))
                        || $(el).is('.dd-handle')) {
                        nestable.clickElement(el, true);
                    }
                }
            } else {
                if ((!/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.btn-header').length && !$(el).parents('.ui-datepicker-calendar').length && el.id !== 'hide-menu' && $(el).parents().id !== 'hide-menu' && (!utils.isUndefined(el.hash) && !/^#/.test(el.hash))
                    && (!utils.isUndefined($(el).parents('a,button,.tt-datatable td').hash) && !/^#/.test($(el).parents('a,button,.tt-datatable td').hash)))
                    || $(el).is('.dd-handle')) {
                    nestable.clickElement(el, true);
                }
            }

            defer.resolve(true);
        } else if (/\/doc/.test(window.location.pathname)) {

            if (!utils.GLOBALS.programmaticClick) {
                var form = null;
                var content_detail_master = utils.getMaster();
                var content_detail_course = utils.getCourse();
                var content_detail_questionnaire = utils.getQuestionnaire();

                var checkActiveForm = $('#save_request').val() === '1';
                var activeForm = null;
                var isDirty = false;
                var elementIsOnForm = false;
                var formArray = [];
                jQuery.each($(content_detail_master).find('form.tt-view-form'), function (i, form) {
                    if (!checkActiveForm || (checkActiveForm && $('[href="#content-detail-master"]').parent().hasClass('active') && $($(form).parents('.tab-pane')[0]).hasClass('active'))) {
                        if ($(form).hasClass('dirty')) {
                            isDirty = true;
                        }
                        activeForm = form;
                    }
                    formArray.push(form);
                });
                jQuery.each($(content_detail_course).find('form.tt-view-form'), function (i, form) {
                    if (!checkActiveForm || (checkActiveForm && $('[href="#content-detail-course"]').parent().hasClass('active') && $($(form).parents('.tab-pane')[0]).hasClass('active'))) {
                        if ($(form).hasClass('dirty')) {
                            isDirty = true;
                        }
                        activeForm = form;
                    }
                    formArray.push(form);
                });
				jQuery.each($(content_detail_questionnaire).find('form.tt-view-form'), function (i, form) {
					if (!checkActiveForm || (checkActiveForm && $('[href="#content-detail-questionnaires"]').parent().hasClass('active') && $($(form).parents('.tab-pane')[0]).hasClass('active'))) {
						if ($(form).hasClass('dirty')) {
							isDirty = true;
						}
						activeForm = form;
					}
					formArray.push(form);
				});

                if (checkActiveForm) {
                    if (!utils.isUndefined(activeForm) && activeForm.contains(el)) {
                        elementIsOnForm = true;
                    }
                } else {
                    if ((!utils.isUndefined(content_detail_master) && content_detail_master.length && content_detail_master[0].contains(el)) || (!utils.isUndefined(content_detail_course) && content_detail_course.length && content_detail_course[0].contains(el)) || (!utils.isUndefined(content_detail_questionnaire) && content_detail_questionnaire.length && content_detail_questionnaire[0].contains(el))) {
                        elementIsOnForm = true;
                    }
                }

                //console.log('isDirty: ' + isDirty);
                //console.log('elementIsOnForm: ' + elementIsOnForm);

                var parents = $(el).parents('a,button:not(.tt-completeness-button),.tt-datatable td,.dd-handle:not(.dd-completeness-parent)');

                if (isDirty && ($(el).is('a,button:not(.tt-completeness-button),td,.dd-handle:not(.dd-completeness-parent),.dd3-content') || $(el).parents('a,button:not(.tt-completeness-button),.tt-datatable td,.tt-datatable-data td,.dd-handle:not(.dd-completeness-parent),.dd3-content').length || $(el).parents('.input-group').find('.tt-data-collection-type').length || ($(el).hasClass('tt-datatable-patient-search') && $(el).parents('.tt-content-datatable').find('table').length && $(el).parents('.tt-content-datatable').find('table')[0].id === 'table_patientlist' && $('#cancel_patient_search').val() === '1'))
                    && (!elementIsOnForm || $(el).hasClass('tt-next-examination') || parents.hasClass('tt-next-examination') || $(el).hasClass('tt-previous-examination') || parents.hasClass('tt-previous-examination') || $(el).parents('.input-group').find('.tt-data-collection-type').length)
                    && !/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.tt-btn-header').length && !$(el).is('.dropdown-toggle') && !$(el).parents('.dropdown-toggle').length && !$(el).parents('.ui-datepicker-calendar').length
                    && $(el).parents('.tt-agreement-widget').length <= 0 && $(el).parents('.tt-agreement-dialog').length <= 0 && $(el).parents('.tt-completeness-master-list,.tt-completeness-current-course-list').length <= 0 && $(el).parents('#save_conflicts_dialog').length <= 0) {

                    //console.log("1");
                    // Abbrechen, Speichern und Tabelle weiter und zurück dürfen nicht berücksichtigt werden
                    if (!($(el).hasClass('tt-save-views') || $(el).hasClass('tt-cancel-views') || $(el).hasClass('tt-save') || $(el).hasClass('tt-dialog-cancel') || $(el).hasClass('tt-datatable-previous') || $(el).hasClass('tt-info-completeness') || $(el).hasClass('tt-datatable-next') || $(el).hasClass('ui-datepicker-next') || $(el).hasClass('ui-datepicker-prev') || $(el).hasClass('jarviswidget-toggle-btn') || $(el).hasClass('tt-save-transfer-data') || $(el).hasClass('tt-save-without-data')
                        || parents.hasClass('tt-save-views') || parents.hasClass('tt-cancel-views')|| parents.hasClass('tt-save') || parents.hasClass('tt-dialog-cancel') || parents.hasClass('tt-datatable-previous') || parents.hasClass('tt-info-completeness') || parents.hasClass('tt-datatable-next') || parents.hasClass('ui-datepicker-next') || parents.hasClass('ui-datepicker-prev')
                        || parents.hasClass('jarviswidget-toggle-btn') || parents.hasClass('tt-save-transfer-data') || parents.hasClass('tt-save-without-data') || ($(el).parents('ul.tt-input-dropdown').length && $(el).parents('.header-dropdown-list').length <= 0) || (!checkActiveForm && $(el).parents('.tt-nav-tabs').length))) {

                        //console.log("2");
                        e.stopPropagation();
                        e.preventDefault();

                        if (utils.GLOBALS.runningSaveRequest !== null && utils.GLOBALS.runningSaveRequest.state() === 'pending') {

                            $.SmartMessageBox({
                                title: "<i class='fad fa-exclamation txt-color-orangeDark'></i>  <span class='txt-color-orangeDark'><strong>" + Lang.get('tripletrax.unsaved_changes') + "</strong></span>",
                                content: Lang.get('tripletrax.save_changes_running'),
                                buttons: '[' + Lang.get('tripletrax.ok') + ']'
                            }, function (ButtonPressed) {

                                defer.resolve(false);
                                return;
                            });
                        } else {

                            $.SmartMessageBox({
                                title: "<i class='fad fa-exclamation txt-color-orangeDark'></i>  <span class='txt-color-orangeDark'><strong>" + Lang.get('tripletrax.unsaved_changes') + "</strong></span>",
                                content: Lang.get('tripletrax.save_changes'),
                                buttons: '[' + Lang.get('tripletrax.cancel') + '][' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                            }, function (ButtonPressed) {

                                var selectedTableId = -1;
                                var tableId = '';
                                var isPatientSearchClick = false;
                                if ($(el).parents('table').length) {
                                    selectedTableId = $(el).parents('tr')[0].id;
                                    tableId = $(el).parents('table')[0].id;
                                } else if ($(el).hasClass('tt-datatable-patient-search') && $(el).parents('.tt-content-datatable').find('table').length) {
                                    tableId = $(el).parents('.tt-content-datatable').find('table')[0].id;
                                    isPatientSearchClick = true;
                                }

                                if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                    if ($('[href="#content-detail-completeness"]').parent().hasClass('active')) {
										$('[href="#content-detail-course"]').click();
                                    }
                                    saveViews(false).done(function () {
                                        jQuery.each(formArray, function (i, form) {
                                            $(form).find('[calculate-other-examinations]').removeAttr('calculate-other-examinations');
                                            $(form).find('[check-completeness-all-patient]').removeAttr('check-completeness-all-patient');
                                            $(form).find('[check-completeness-all-examination]').removeAttr('check-completeness-all-examination');
                                            $(form).removeClass('dirty');
                                            $(form).trigger('reinitialize.areYouSure');
                                        });
                                        if (tableId === 'table_patientlist') {
                                            cancelViews(isPatientSearchClick, true, !isPatientSearchClick);
                                        }

                                        utils.updateGlobals('programmaticClick', true);
                                        if (selectedTableId >= 0) {
                                            $('#' + tableId).DataTable().page.jumpToData(parseInt(selectedTableId), 0);
                                            $('#' + tableId).find('tr[id="' + selectedTableId + '"]').find('td')[0].click();
                                        } else {
                                            el.click();
                                        }
                                        utils.updateGlobals('programmaticClick', false);
                                        defer.resolve(true);
                                    })
                                } else if (ButtonPressed === Lang.get('tripletrax.no')) {
                                    if (checkActiveForm) {
                                        var patientData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data');
                                        var courseData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data');
                                        patients.setData($(activeForm).parent(), jQuery.extend({}, courseData, patientData), true, true, true, true, false).done(function () {
                                            views.setFormDataForAjaxCall($(activeForm).parent(), true, true);
                                        });

                                        $(activeForm).find('[calculate-other-examinations]').removeAttr('calculate-other-examinations');
                                        $(activeForm).find('[check-completeness-all-patient]').removeAttr('check-completeness-all-patient');
                                        $(activeForm).find('[check-completeness-all-examination]').removeAttr('check-completeness-all-examination');
                                        $(activeForm).removeClass('dirty');
                                        $(activeForm).trigger('reinitialize.areYouSure');
                                    } else {
										var examIdCompleteness = null;
										var fieldNameCompleteness = null;
                                        if ($(el).hasClass('tt-previous-examination') || parents.hasClass('tt-previous-examination') || $(el).hasClass('tt-next-examination') || parents.hasClass('tt-next-examination')
											|| $(el).hasClass('dd-handle-completeness') || parents.hasClass('dd-handle-completeness')
                                            || $(el).parents('.tt-widget-data-collection-type').length || $(el).parents('.tt-widget-examination').length
                                            || $(el).parents('.input-group').find('.tt-data-collection-type').length
                                            || $(el).hasClass('tt-create-examination') || parents.hasClass('tt-create-examination') || tableId === 'table_patient_examination') {
                                            if ($(el).parents('.input-group').find('.tt-data-collection-type').length <= 0) {

                                                if (!$(el).hasClass('dd-handle-completeness') && !parents.hasClass('dd-handle-completeness')) {
													cancelViews(false, true);
												}
                                            }
                                            var patientData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data');
                                            utils.detachMaster();
                                            var master = utils.getMaster();
                                            jQuery.each(master.find('.tt-doc-pane.data-loaded'), function (i, tab) {
                                                patients.setData($(tab), patientData, true, true, true, true, false).done(function () {
                                                    views.setFormDataForAjaxCall($(tab), true, true);
                                                });
                                            });

											master.find('form').removeClass('dirty');
											master.find('form').trigger('reinitialize.areYouSure');
											utils.appendMaster();
                                        } else {
                                            cancelViews(isPatientSearchClick ? true : tableId !== 'table_patientlist', true, !isPatientSearchClick);
                                        }

                                        jQuery.each(formArray, function (i, form) {
                                            $(form).removeClass('dirty');
                                            $(form).trigger('reinitialize.areYouSure');
                                        });
                                    }

                                    utils.updateGlobals('programmaticClick', true);
                                    if (selectedTableId >= 0) {
                                        $('#' + tableId).DataTable().page.jumpToData(parseInt(selectedTableId), 0);
                                        $('#' + tableId).find('tr[id="' + selectedTableId + '"]').find('td')[0].click();
                                    } else {
										el.click();
                                    }
                                    utils.updateGlobals('programmaticClick', false);
                                    defer.resolve(true);
                                } else if (ButtonPressed === Lang.get('tripletrax.cancel')) {
                                    defer.resolve(false);
                                    return;
                                }
                            });
                        }
                    }
                } else {
                    if (!/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.btn-header').length && !$(el).parents('.ui-datepicker-calendar').length && el.id !== 'hide-menu' && $(el).parents().id !== 'hide-menu' && (!utils.isUndefined(el.hash) && !/^#/.test(el.hash))
                        && (!utils.isUndefined($(el).parents('a,button,.tt-datatable td').hash) && !/^#/.test($(el).parents('a,button,.tt-datatable td').hash))) {
                        el.click();
                    }
                    defer.resolve(true);
                }
            } else {
                if (!/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.btn-header').length && !$(el).parents('.ui-datepicker-calendar').length && el.id !== 'hide-menu' && $(el).parents().id !== 'hide-menu' && (!utils.isUndefined(el.hash) && !/^#/.test(el.hash))
                    && (!utils.isUndefined($(el).parents('a,button,.tt-datatable td').hash) && !/^#/.test($(el).parents('a,button,.tt-datatable td').hash))) {
                    el.click();
                }
                defer.resolve(true);
            }
        }
    });
}

function cancelViews(isMaster, resetSelectedRow, resetPatientSearch) {

	if ($('#live_completeness_check').val() !== '1') {
		$('.tt-completeness-on-save').removeClass('hide');
		$('.tt-completeness-live').addClass('hide');
	}
	utils.detachCourse();
	var course = utils.getCourse();
    patients.resetForms(course, true, false);
	course.find('.tt-doc-pane.data-loaded').removeClass('data-loaded');
	course.find('.tt-transfer-data-button-group').addClass('hide');
	utils.appendCourse();
    validator.setCourseContentVisible(false);

	utils.detachQuestionnaire();
	var questionnaire = utils.getQuestionnaire();
	if (!utils.isUndefined(questionnaire)) {
		patients.resetForms(questionnaire, true, false);
		questionnaire.find('.tt-doc-pane.data-loaded').removeClass('data-loaded');
		utils.appendQuestionnaire();
		validator.setQuestionnaireContentVisible(false);
	}

	cancelCompleteness(!isMaster);
    if ($('.tt-nav-content-article').find('.tt-selected-examination-id').val() === '0') {
        $('#table_patient_examination').DataTable().row($('#table_patient_examination').dataTable().$('tr[id="0"]')[0]).remove().draw();
    }
    $('.tt-nav-content-article').find('.tt-selected-examination-id').val('');
    $('.tt-nav-content-article').find('.tt-selected-examination-date').val('');
    $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', []);
    $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data', '');
    $('.tt-nav-content-article').find('.tt-selected-examination-id').data('transfer_examination_data', null);
    $('.tt-nav-content-article').find('.tt-selected-examination-id').data('tab_transfer_data', null);
    $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data_is_set', false);
    $('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data', '');
    if (resetSelectedRow) {
        $('#table_patient_examination').dataTable().$('tr.selected-row').removeClass('selected-row');
    }
    $('#table_patient_examination').parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');

    if (isMaster) {
        cancelReports();
		utils.detachMaster();
		var master = utils.getMaster();
        patients.resetForms(master, true, false);
		master.find('.tt-doc-pane.data-loaded').removeClass('data-loaded');
		utils.appendMaster();
        validator.setMasterContentVisible(false);
        $('.tt-selected-id').val('');
        $('.tt-selected-patient-is-active').val('');
		$('.tt-selected-patient-is-locked').val('');
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', []);
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data', '');
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data_is_set', '');
        patients.loadAgreementList('0', 0);
        //var newTableUrl = $('#table_patient_agreement').dataTable().data().tableUrl.substring(0, $('#table_patient_agreement').dataTable().data().tableUrl.lastIndexOf('/')) + "/0/datatable";
        //reloadTable('#table_patient_agreement', newTableUrl);
        $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-dialog-open').addClass('disabled');
		$('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-dialog-open').prop('disabled', 'disabled');
        $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-show-agreement-list').addClass('disabled');
        $('#table_patient_examination').dataTable().api().clear().draw();
        $('#table_patient_examination').parents('.tt-content-datatable').find('.tt-dialog-open').addClass('disabled');
		$('#table_patient_examination').parents('.tt-content-datatable').find('.tt-dialog-open').prop('disabled', 'disabled');
        if (utils.isUndefined(resetPatientSearch) || resetPatientSearch) {
            $('#table_patientlist').parents('.tt-content-datatable').find('.tt-datatable-search').val('');
        }
        if (resetSelectedRow) {
            $('#table_patientlist').dataTable().$('tr.selected-row').removeClass('selected-row');
        }
        $('#table_patientlist').dataTable().fnFilterClear();
        $('#table_patientlist').parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
        utils.GLOBALS.runningAjaxRequests.length = 0;
        $('[href="#content-detail-patientlist"]').click();

    }
}

function cancelReports() {

    $('.tt-select-patient-report').val(null).trigger('change.select2');
    $('#content-detail-reports-detail').empty();
    validator.setReportsContentVisible(false);
}

function cancelCompleteness(state) {
	$('#dd_completeness').data('data-date-range-set', false);
	$('.tt-completeness-master').remove();
	$('.tt-completeness-current-course').remove();
	$('.tt-completeness-course').remove();
	$('.tt-pulsate').each(function () {
		$(this).pulsate('destroy');
		$(this).removeClass('tt-pulsate');
	});
	$('.tt-back-to-completeness-button').parent().addClass('hide');
	$('#count_missing_fields').text('');
	validator.setCompletenessContentVisible(state);
}

function saveViews(resetForms) {
    $('.tt-save-views').attr('disabled', 'disabled');
    $('.tt-wait-for-saving').removeClass('hide');

    utils.GLOBALS.runningSaveRequest = $.Deferred(function(defer) {

        if (utils.GLOBALS.timerIntegrity) {
            clearTimeout(utils.GLOBALS.timerIntegrity); //cancel the previous timer.
            utils.GLOBALS.timerIntegrity = null;
            views.checkIntegrity($.merge([], utils.GLOBALS.integrityControlList), true, false, null, true);
        }
        utils.GLOBALS.runningAjaxRequests.push(utils.GLOBALS.runningCompletenessRequest);
        if (utils.GLOBALS.startNewCompletenessRequest || $('#live_completeness_check').val() !== '1') {
            utils.GLOBALS.startNewCompletenessRequest = false;
            views.setCompleteness(null, null, true, 1, true);
        }
        // for (var i = 0; i < utils.GLOBALS.runningAjaxRequests.length; i++) {
        //  console.log(i + ': ' + utils.GLOBALS.runningAjaxRequests[i].state());
        // }
        $.when.apply($, $.merge( $.merge( [], utils.GLOBALS.runningTableClickRequests), utils.GLOBALS.runningAjaxRequests)).done(function () {
            utils.GLOBALS.runningAjaxRequests.length = 0;
            // Prüfung ob keine unplausiblen Integritäten bestehen; Unplausibilitäten aus dem Import können unverändert gespeichert werden
            var doSave = true;
            var showValidation = true;
            var course = utils.getCourse();
            var master = utils.getMaster();
			var formData = views.getFormDataForAjaxCall(false, true, true);
            // Selbst definierte Integritäts-Regeln
            jQuery.each(formData.split('&'), function (i, element) {
                if (/_confirmed$/.test(element.split('=')[0])) {
					var elementName = (element.split('=')[0]).replace('_confirmed', '');
					var rule = decodeURIComponent(element.split('=')[1]);
                    var confirmed = (rule).split('§')[1];
					var integrityOriginFlag = (rule).split('§')[3];
					if (confirmed === '0' && (utils.isUndefined(integrityOriginFlag) || !utils.isIgnoreFlagForIntegrityCheck(integrityOriginFlag))) {
					    doSave = false;
						// zu Feld springen, welches noch unplausibel ist
                        var showColumn = false;
                        var elementNameToFind = elementName;
                        var elementToFind = $('[name="' + elementName + '"]');
                        var columnIndex;
						if (/_spalte_[0-9]$/.test(elementName)) {
						    if (!elementToFind.length) {
						        elementToFind = $('[name="' + elementName.substr(0, elementName.lastIndexOf('_spalte_')) + '"]');
                            }
                            if (!elementToFind.length) {
								elementToFind = $('[name^="' + elementName.substr(0, elementName.lastIndexOf('_')) + '"]');
                            }
                            if (elementToFind.length) {
								elementNameToFind = elementToFind[0].name;
							}
						    columnIndex = elementName.substr(elementName.lastIndexOf('_') + 1);
						} else {
							if (!elementToFind.length) {
								elementToFind = $('[name^="' + elementName + '_spalte_"]');
							}
							if (elementToFind.length) {
								elementNameToFind = elementToFind[0].name;
							}
							columnIndex = 1;
                        }
						if (elementName !== elementNameToFind) {
						    showColumn = true;
                        }
                        if (master.find('[name="' + elementNameToFind + '"],[data-database-table-name="' + elementName + '"]').length) {
							$('[href="#content-detail-master"]').tab('show');
							var controlTabPaneId = $($(master.find('[name="' + elementNameToFind + '"],[data-database-table-name="' + elementName + '"]')[0]).parents('.tab-pane')[0]).attr('id');
							$('[href="#' + controlTabPaneId + '"]').click();
							if (showColumn) {
								var tabButtonGroup = $($(elementToFind).parents('.tt-column')[0]).find('.tt-tab-button-group');
								$(tabButtonGroup).find('input:checked').prop('checked', false);
								$(tabButtonGroup).find('input[value="' + columnIndex + '"]').prop('checked', true);
								$(tabButtonGroup).find('.tt-tab-button').removeClass('active');
								$(tabButtonGroup).find('input[value="' + columnIndex + '"]').parent().addClass('active');
								views.showColumn($($(elementToFind).parents('.tt-column')[0]).find('.tt-column-panel,.tt-panel'), columnIndex, true);
                            }
							$(master.find('[name="' + elementName + '"],[data-database-table-name="' + elementName + '"]')[0]).focus();
						} else if (course.find('[name="' + elementNameToFind + '"],[data-database-table-name="' + elementName + '"]').length) {
							$('[href="#content-detail-course"]').tab('show');
							var controlTabPaneId = $($(course.find('[name="' + elementNameToFind + '"],[data-database-table-name="' + elementName + '"]')[0]).parents('.tab-pane')[0]).attr('id');
							$('[href="#' + controlTabPaneId + '"]').click();
							if (showColumn) {
								var tabButtonGroup = $($(elementToFind).parents('.tt-column')[0]).find('.tt-tab-button-group');
								$(tabButtonGroup).find('input:checked').prop('checked', false);
								$(tabButtonGroup).find('input[value="' + columnIndex + '"]').prop('checked', true);
								$(tabButtonGroup).find('.tt-tab-button').removeClass('active');
								$(tabButtonGroup).find('input[value="' + columnIndex + '"]').parent().addClass('active');
								views.showColumn($($(elementToFind).parents('.tt-column')[0]).find('.tt-column-panel,.tt-panel'), columnIndex, true);
                            }
							$(course.find('[name="' + elementName + '"],[data-database-table-name="' + elementName + '"]')[0]).focus();
                        }
						utils.updateGlobals('controlNameForFocus', elementName);

						return false;
                    }
				}
            });
            if (doSave) {
				// Integritäts-Regeln des Validators (Stammdaten)
                jQuery.each(master.find('.tt-validation-form'), function (i, form) {
                    if (!$(form).valid()) {
                        doSave = false;
                        showValidation = false;
                        // zu Feld springen, welches noch unplausibel ist
                        $('[href="#content-detail-master"]').tab('show');
                        var controlTabPaneId = $($(master.find('#' + form.id)[0]).parents('.tab-pane')[0]).attr('id');
                        $('[href="#' + controlTabPaneId + '"]').click();
                        return false;
                    }
                });
            }
            if (doSave) {
				// Integritäts-Regeln des Validators (Verlaufsdaten)
                jQuery.each(course.find('.tt-validation-form'), function (i, form) {
                    if (!$(form).valid()) {
                        doSave = false;
                        showValidation = false;
                        // zu Feld springen, welches noch unplausibel ist
                        $('[href="#content-detail-course"]').tab('show');
                        var controlTabPaneId = $($(course.find('#' + form.id)[0]).parents('.tab-pane')[0]).attr('id');
                        $('[href="#' + controlTabPaneId + '"]').click();
                        return false;
                    }
                });
            }

            if (!doSave) {
                $('.tt-save-views').removeAttr('disabled');
                $('.tt-wait-for-saving').addClass('hide');
                if (showValidation) {
                    validator.showValidationMessage();
                }
                defer.reject();
                return;
            }

            // Meldung anzeigen, wenn Felder in anderen Untersuchungen neu berechnet werden müssen
            var fieldsToCalculateOtherExaminations = [];
            jQuery.each(utils.getMaster().find('[calculate-other-examinations]'), function (i, element) {
                var calculations = element.getAttribute('calculate-other-examinations').split(',');
                jQuery.each(calculations, function (i, val) {
                    if (jQuery.inArray(val, fieldsToCalculateOtherExaminations) < 0) {
                        fieldsToCalculateOtherExaminations.push(val);
                    }
                });
            });

            if (fieldsToCalculateOtherExaminations.length > 0) {
                var fieldsToCalculateOtherExaminationsString = '<ul>';
                jQuery.each(fieldsToCalculateOtherExaminations, function (i, val) {
                    fieldsToCalculateOtherExaminationsString += '<li>' + val + '</li>';
                });
                fieldsToCalculateOtherExaminationsString += '</ul>';

                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation txt-color-orangeDark'></i>  <span class='txt-color-orangeDark'><strong>" + Lang.get('tripletrax.calculate_fields_other_examinations_title') + "</strong></span>",
                    content: Lang.get('tripletrax.calculate_fields_other_examinations_desc', { "calculations": fieldsToCalculateOtherExaminationsString}),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                });
            }

            var patientData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data');

            var patientname = views.getControlValue(master.find('[data-match-field="patientname"]'));
            var prename = views.getControlValue(master.find('[data-match-field="prename"]'));
            var birthDate = views.getControlValue(master.find('[data-match-field="birth_date"]'));
            var gender = views.getControlValue(master.find('[data-match-field="gender"]'));
            var street = views.getControlValue(master.find('[data-match-field="street"]'));
            var postalCode = views.getControlValue(master.find('[data-match-field="postal_code"]'));
            var city = views.getControlValue(master.find('[data-match-field="city"]'));
            var birthName = views.getControlValue(master.find('[data-match-field="birth_name"]'));
            var birthCity = views.getControlValue(master.find('[data-match-field="birth_city"]'));
            var state = views.getControlValue(master.find('[data-match-field="state"]'));

            saveIDATData(patientData, prename, patientname, birthDate, gender, street, postalCode, city, birthName, birthCity).done(function (savePatientData, loadPatientList, loadIDATData) {

                if (savePatientData) {
                    if (master.find('[data-match-field="state"]').length && state.split('=')[0] !== patientData[master.find('[data-match-field="state"]').attr('name')]) {
                        loadPatientList = true;
                    }

                    var existingExaminationData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data');
                    var existingPatientData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data');
                    var existingData = jQuery.extend({}, existingExaminationData, existingPatientData);

                    formData += '&existingData=' + encodeURIComponent(JSON.stringify(existingData));

                    saveViewsAjaxCall(formData, resetForms, loadPatientList, loadIDATData)
                        .done(function () {
                            defer.resolve();
                        })
                        .fail(function (data) {
                            if (data.length === 5) {
                                getSaveConflictsDataForm(data[1], data[2], data[3], data[4]);
                            }
                            defer.reject();
                        });
                } else {
                    $('.tt-save-views').removeAttr('disabled');
                    $('.tt-wait-for-saving').addClass('hide');
                    defer.reject();
                }
            });
        }).promise();
    });

    return utils.GLOBALS.runningSaveRequest;
}

function getSaveConflictsDataForm(databaseData, conflicts, matchFields, existingData) {

    if (!utils.isUndefined(conflicts) && Object.keys(conflicts).length > 0) {

        // gespeicherte Änderungen der Datenbank + Match-Fields in Input schreiben
        // -> diese werden dann später (nach dem Lösen der Konflikte) benötigt
        $('#save_conflicts_dialog').find('[name="database_data"]').val(JSON.stringify(databaseData));
        $('#save_conflicts_dialog').find('[name="match_fields"]').val(JSON.stringify(matchFields));
        $('#save_conflicts_dialog').find('[name="existing_patient_data"]').val(JSON.stringify(existingData[0]));
        if (views.isExaminationSelected()) {
            $('#save_conflicts_dialog').find('[name="existing_examination_data"]').val(JSON.stringify(existingData[4]));
        }

        $("#table_save_conflicts").dataTable().fnClearTable();

        for (var key in conflicts) {

            $("#table_save_conflicts").dataTable().fnAddData([
                conflicts[key][1],
                conflicts[key][2],
                JSON.stringify(conflicts[key][3]),
                JSON.stringify(conflicts[key][4])]
            );
        }

        $('#save_conflicts_dialog').modal("show");

    } else {

        var newData = databaseData['0000-00-00'];
        if (views.isExaminationSelected()) {
            newData = jQuery.extend({}, databaseData['0000-00-00'], databaseData[views.getExaminationDate()]);
        }

        // IDAT-Daten hinzufügen
        var aPos = $('#table_patientlist').dataTable().fnGetPosition($('#table_patientlist').find('tr[id="' + views.getPatientId() + '"]')[0]);
        var aData = $('#table_patientlist').dataTable().fnGetData(aPos);
        newData = patients.mergePatientAndIDATData(aData, newData, matchFields);

        // Array mit den aktuellen Daten neu setzen
        if (views.isExaminationSelected()) {
            $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', newData);
        } else {
            $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', newData);
        }

        // für alle Tabs, die die Klasse data-loaded besitzen, die Daten setzen
        jQuery.each($('#content').find('.tt-doc-pane.data-loaded'), function (i, tab) {

            var isOwnFacility = true;
            if ($(tab).parents('#content-detail-course').length) {
                isOwnFacility = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id').toString() === views.getFacilityId().toString();
            }

            patients.setData($(tab), newData, true, false, true, isOwnFacility, false);
        });

        // bestehende Daten neu setzen
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data', patients.mergePatientAndIDATData(aData, existingData[0], matchFields));
        if (views.isExaminationSelected()) {
            $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data', existingData[4]);
        }

        // erneut speichern
        $('#content').find('.tt-save-views')[0].click();
    }
}

function saveViewsAjaxCall(formData, resetForms, loadPatientList, loadIDATData) {
    return $.Deferred(function (defer) {

        var url = 'doc/patient/patient/' + views.getPatientId() + '/facility/' + views.getFacilityId() + '/model/' + views.getModelId() + '/examination/' + views.getExaminationDate();

        ajax.ajaxCallDeferred(url, 'POST', formData, false)
            .done(function (data) {
                if (ajax.ajaxSucceeded(data)) {

                    if (data.length === 5 && data[0] === 'UPDATED') {
                        $('.tt-save-views').removeAttr('disabled');
                        $('.tt-wait-for-saving').addClass('hide');
                        defer.reject(data);
                    } else {
                        var patientId = $('.tt-nav-content-article').find('.tt-selected-id').val();
                        if (loadPatientList) {

                            patients.loadPatientlist(loadIDATData).done(function (patientData) {

                                var list_data = patients.getPatientlist(patientData);
                                $('#table_patientlist').dataTable().api().clear().rows.add(list_data).draw();

                                $('#table_patientlist').DataTable().page.jumpToData(parseInt(patientId), 0);
                                if ($('#table_patientlist').find('tr[id="' + patientId + '"]').length) {
									$('#table_patientlist').find('tr[id="' + patientId + '"]').addClass('selected-row');

									validator.setExaminationList(false).done(function () {
										setValuesAfterSaving(data, resetForms, patientId);
										defer.resolve();
									});
								} else {
									cancelViews(true, true);
                                }
                            });
                        } else {
                            validator.setExaminationList(false).done(function () {
                                setValuesAfterSaving(data, resetForms, patientId);
                                defer.resolve();
                            });
                        }
                    }
                } else {
                    $('.tt-save-views').removeAttr('disabled');
                    $('.tt-wait-for-saving').addClass('hide');
                    defer.reject();
                }
            });
    }).promise();
}

function setValuesAfterSaving(data, resetForms, patientId) {
    var examinationId = $('.tt-nav-content-article').find('.tt-selected-examination-id').val();
    if (examinationId === 0 || examinationId === '0') {
        examinationId = data[2];
    }
    utils.getCourse().find('.tt-select-examination-dropdown').find('li[data-examination-id="' + examinationId + '"]').addClass('active');
    var questionnaire = utils.getQuestionnaire();
	if (!utils.isUndefined(questionnaire)) {
		questionnaire.find('.tt-select-examination-dropdown').find('li[data-examination-id="' + examinationId + '"]').addClass('active');
	}
    $('#table_patient_examination').DataTable().page.jumpToData(parseInt(examinationId), 0);
    $('#table_patient_examination').find('tr[id="' + examinationId + '"]').addClass('selected-row');
    $('.tt-nav-content-article').find('.tt-selected-examination-id').val(examinationId);
    $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id', views.getFacilityId());
	$('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_locked', null);

    if (resetForms) {
        cancelViews(true, true);
    } else {
        // Stammdaten neu setzen
        var aData = $.grep($('#table_patientlist').DataTable().data(), function(e){ return e.id == patientId; });
        var formData = patients.mergePatientAndIDATData(aData[0], data[0], data[1]);
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data', formData);
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', jQuery.extend({}, formData));

        jQuery.each($('[data-database-table-name]'), function(i, table) {

            if ($(table).hasClass('tt-accordion')) {
                jQuery.each($(table).find('.tt-accordion-panel'), function(k, panel) {

                    if ($(table).data().databaseTableName + '_rowid__' + $(panel).data().rowId in data[3]) {
                        $(panel).data('dataId', data[3][$(table).data().databaseTableName + '_rowid__' + $(panel).data().rowId]);
                    }
                });
            } else {
                var dataTable = $(table).DataTable();
                for (var l = 0; l < dataTable.data().length; l++) {
                    var row = $(dataTable.row(l).node());
                    if ($(table).data().databaseTableName + '_rowid__' + row.data().rowId in data[3]) {
                        row.data('dataId', data[3][$(table).data().databaseTableName + '_rowid__' + row.data().rowId]);
                    }
                }
            }
        });

        utils.detachMaster();
		views.setValues(utils.getMaster(), formData, false, true);
		utils.appendMaster();

        if (data.length > 4) {
            $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data', data[4]);
            $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', jQuery.extend({}, formData, data[4]));
			utils.detachCourse();
            views.setValues(utils.getCourse(), $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data'), false, true);
			utils.appendCourse();
        }

        // Report Daten neu laden
        reports.setChartPage();
    }
    $('.tt-load-notifications').click();
    $('.tt-save-views').removeAttr('disabled');
    $('.tt-wait-for-saving').addClass('hide');
}

function saveIDATData(patientData, prename, patientname, birthDate, gender, street, postalCode, city, birthName, birthCity) {

    return $.Deferred(function (defer) {

        if (access.showPatientsAnonymized() === 0 && utils.GLOBALS.idatPatients !== null) {
            var master = utils.getMaster();
            if (patientname.split('=')[0] !== patientData[master.find('[data-match-field="patientname"]').attr('name')] ||
                prename.split('=')[0] !== patientData[master.find('[data-match-field="prename"]').attr('name')] ||
                birthDate.split('=')[0] !== utils.dateToString(patientData[master.find('[data-match-field="birth_date"]').attr('name')]) ||
                gender.split('=')[0] !== patientData[master.find('[data-match-field="gender"]').attr('name')] ||
                street.split('=')[0] !== patientData[master.find('[data-match-field="street"]').attr('name')] ||
                postalCode.split('=')[0] !== patientData[master.find('[data-match-field="postal_code"]').attr('name')] ||
                city.split('=')[0] !== patientData[master.find('[data-match-field="city"]').attr('name')] ||
                birthName.split('=')[0] !== patientData[master.find('[data-match-field="birth_name"]').attr('name')] ||
                birthCity.split('=')[0] !== patientData[master.find('[data-match-field="birth_city"]').attr('name')]) {

                patients.changePatientInIDAT(patientData["pseudonym"], prename, patientname, birthDate, gender, street, postalCode, city, birthName, birthCity).done(function (loadIDATData) {
                    defer.resolve(loadIDATData, true, true);
                });
            } else {
                defer.resolve(true, false, false);
            }
        } else {
            defer.resolve(true, false, false);
        }
    }).promise();
}

function reloadTable(table, url) {
    $(table).DataTable().ajax.url(url).load();

    $(table).parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
    $(table).parents('.tt-content-datatable').find('.tt-show-document').addClass('disabled');
    $(table).parents('.tt-content-datatable').find('.tt-print-document').addClass('disabled');
}

function tableSingleClick(element, childElement) {
    return $.Deferred(function (defer) {

        // Element nach dem Speichern wieder finden
        if (!utils.isUndefined(element) && !utils.isUndefined(element[0].id)) {
            if (element.parents('.tt-datatable,.tt-datatable-data').length) {
                var table_id = element.parents('.tt-datatable,.tt-datatable-data')[0].id;
                element = $('#' + table_id).find('#' + element[0].id);
            } else {
                element = $('#' + element[0].id);
            }
        }

        var dataTable = element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data').dataTable();
        var table = element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data');
        var aPos = dataTable.fnGetPosition(element[0]);
        var aData = dataTable.fnGetData(aPos);

        if (!element.hasClass('selected-row')) {
            if (table[0].id === 'table_doc_documents' || table[0].id === 'table_audit_trail') {
                defer.resolve();
                return;
            } else if (table[0].id === 'table_mails' && !utils.isUndefined(childElement)) {
                if (childElement.hasClass('tt-selection-column')) {
                    var selected = !childElement.find('input[type="checkbox"]').prop('checked');
                    childElement.find('input[type="checkbox"]').prop('checked', selected);

                    if (selected) {
                        if ($.inArray(aData[0], utils.GLOBALS.mailsUnselected) >= 0)
                        {
                            utils.GLOBALS.mailsUnselected = jQuery.grep(utils.GLOBALS.mailsUnselected, function(value) {
                                return value != aData[0];
                            });
                        }
                        utils.GLOBALS.mailsSelected.push(aData[0]);
                    } else {
                        if ($.inArray(aData[0], utils.GLOBALS.mailsSelected) >= 0)
                        {
                            utils.GLOBALS.mailsSelected = jQuery.grep(utils.GLOBALS.mailsSelected, function(value) {
                                return value != aData[0];
                            });
                        }
                        utils.GLOBALS.mailsUnselected.push(aData[0]);
                    }

                    defer.resolve();
                    return;
                }
            } else {
                dataTable.$('tr.selected-row').removeClass('selected-row');
                element.addClass('selected-row');
            }
        }

        var initializeElements = true;
        var newUrl = table[0].getAttribute('data-table-url') + "/" + element[0].id;
        if (table.length && table[0].id === "table_mails") {
            if (table[0].getAttribute('data-table-folder') === "draft") {
                newUrl = table[0].getAttribute('data-table-compose-url') + "/" + element[0].id;
            } else {
                newUrl = table[0].getAttribute('data-table-detail-url') + "/" + element[0].id;
            }
        } else if (table.length && table[0].id === "table_aggregation_definition") {
            newUrl = table[0].getAttribute('data-table-rule-url') + "/" + element[0].id;
        }

        var master = utils.getMaster();
        var course = utils.getCourse();

        if (table.length && table[0].id === "table_patientlist") {

            if ($('.tt-nav-content-article').find('.tt-selected-id').val() === element[0].id) {
                // Patient wurde bereits geladen, nichts machen
                defer.resolve();
                return;
            }

            // console.log(aData['pseudonym']);
            $('.tt-nav-content-article').find('.tt-selected-id').val(element[0].id);
            $('.tt-nav-content-article').find('.tt-selected-patient-is-active').val(aData['state_aggregate']);
			$('.tt-nav-content-article').find('.tt-selected-patient-is-locked').val(aData['locked_patient']);
            master.find('.tt-doc-pane.data-loaded').removeClass('data-loaded');
            $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', []);
            $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data', '');
            $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data_is_set', false);
            $('#table_patient_examination').DataTable().clear().draw();
            $('#table_patient_examination').find('.dataTables_empty').text('').append('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');
            cancelReports();
            cancelCompleteness(false);

            validator.setDataCollectionTypesForPatient().done(function () {

				patients.loadAgreementList(element[0].id, ($(element[0].firstChild).hasClass('tt-locked-patient-or-period') ? 1 : 0));
				//var newTableUrl = $('#table_patient_agreement').dataTable().data().tableUrl.substring(0, $('#table_patient_agreement').dataTable().data().tableUrl.lastIndexOf('/')) + "/" + element[0].id + "/datatable";
				//reloadTable('#table_patient_agreement', newTableUrl);

				validator.setQuestionnaireSelectionList();
                validator.setExaminationList(true);
				if (views.getModelId() > 0) {
                    validator.setMasterContentVisible(true);
                    validator.setReportsContentVisible(true);
                    if ($('[name="show_patients_incomplete_course_data"]').is(':checked')) {
						validator.setCompletenessContentVisible(true);
                    } else {
						validator.setCompletenessContentVisible(false);
                    }
                } else {
                    validator.setMasterContentVisible(false);
                    validator.setReportsContentVisible(false);
                    validator.setCompletenessContentVisible(false);
                }
                validator.setCourseContentVisible(false);
                validator.setQuestionnaireContentVisible(false);
                initializeElements = false;

                newUrl += '/facility/' + views.getFacilityId() + '/model/' + views.getModelId();

                tableSingleClickAjaxCall(element, newUrl, aPos, aData, initializeElements)
                    .done(function() {
                        defer.resolve();
                    });
            });

        } else if (table.length && table[0].id === "table_patient_examination") {

            if ($('.tt-nav-content-article').find('.tt-selected-examination-id').val() === element[0].id) {
                // Untersuchung wurde bereits geladen, nichts machen
                defer.resolve();
                return;
            }

            // console.time('cancelViews');
            cancelViews(false, false);
			// console.timeEnd('cancelViews');
            $('.tt-nav-content-article').find('.tt-selected-examination-id').val(element[0].id);
            $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id', aData.facility_id);
			$('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_locked', aData.locked_patient);
            $('.tt-nav-content-article').find('.tt-selected-examination-date').val(utils.dateToTimeString(aData.examinationdate));
            course.find('.tt-no-selection').addClass('hide');
            course.find('.tt-content-course').removeClass('hide');
            // console.log(utils.dateToTimeString(aData.examinationdate));
			// console.time('setSelectedExamination');
            setSelectedExamination(false, 0);
			// console.timeEnd('setSelectedExamination');
			// console.time('setCourseContentVisible');
            validator.setCourseContentVisible(true);
            validator.setQuestionnaireContentVisible(Object.keys(views.getQuestionnaires()).length > 0);

			// console.timeEnd('setCourseContentVisible');

            if (element[0].id > 0) {
                newUrl = table[0].getAttribute('data-table-selection-url') + "/" + element[0].id + "/facility/" + views.getFacilityId() + "/model/" + views.getModelId();
                initializeElements = false;

				utils.detachCourse();
				// console.time('tableSingleClickAjaxCall');
                tableSingleClickAjaxCall(element, newUrl, aPos, aData, initializeElements)
                    .done(function () {
						// console.timeEnd('tableSingleClickAjaxCall');
						utils.appendCourse();
                        defer.resolve();
                    });
            } else {
                $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', jQuery.extend({}, $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data')));
                $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data', '');
                $('.tt-nav-content-article').find('.tt-selected-examination-id').data('transfer_examination_data', null);
                $('.tt-nav-content-article').find('.tt-selected-examination-id').data('tab_transfer_data', null);
				course.find('.tt-transfer-data-button-group').addClass('hide');
                $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data_is_set', false);
                $('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data', '');
                defer.resolve();
            }
        } else if (table.length && table[0].id === "table_patient_agreement") {

            if (element.parents('.tt-content-datatable').find('.tt-selected-pos').length > 0) {
                element.parents('.tt-content-datatable').find('.tt-selected-pos').val(aPos);
            }

            // Dokumente-Button (Ansehen und Drucken) der jeweiligen Einwilligung definieren
            if (!utils.isUndefined(aData) && !utils.isUndefined(aData.documents)) {
                element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').removeClass('disabled');
                $(element.parents('.tt-content-datatable').find('.tt-show-document,.tt-show-document')).parent().find('ul').remove();
                var splitted_documents = aData.documents.split(',');
                if (splitted_documents.length === 1) {
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').attr('href', aData.documents.split('|')[1]);
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').removeAttr('data-toggle');
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').attr('aria-expanded', false);
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').removeClass('dropdown-toggle');
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').removeClass('userdropdown');

                } else {
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').attr('href', '#');
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').attr('data-toggle', 'dropdown');
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').attr('aria-expanded', true);
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').addClass('dropdown-toggle');
                    element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').addClass('userdropdown');

                    var add_divider = false;
                    var html = '<ul class="dropdown-menu">';

                    jQuery.each(splitted_documents, function (k, doc) {
                        if (add_divider) {
                            html += '<li class="divider"></li>';
                        } else {
                            add_divider = true;
                        }

                        html += '<li><a href="' + doc.split('|')[1] + '">' + doc.split('|')[0] + '</a></li>';
                    });

                    html += '</ul>';

                    //$(element.parents('.tt-content-datatable').find('.tt-show-document')).after(html);
                    $(element.parents('.tt-content-datatable').find('.tt-print-document')).after(html);
                }
            } else {
                element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').addClass('disabled');
                element.parents('.tt-content-datatable').find('.tt-show-document,.tt-print-document').removeAttr('href');
            }

            // Löschen-Button aktiv setzen, wenn das Recht für Löschen der ausgewählten Einwilligung vorhanden ist und der Patient nicht gesperrt ist
            if (!utils.isUndefined(aData) && !utils.isUndefined(aData.data_collection_types) && utils.isUndefined(aData.locked_patient)) {
				jQuery.each(aData.data_collection_types.split('|'), function (i, data_collection_type) {
					if (data_collection_type + '-delete_register_patient-delete' in utils.GLOBALS.rights && utils.GLOBALS.rights[data_collection_type + '-delete_register_patient-delete'] == 1) {
                        element.parents('.tt-content-datatable').find('.tt-delete').removeClass('disabled');
                        return false;
                    } else {
                        element.parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
					}
				});
            } else {
				element.parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
			}
            defer.resolve();
        } else if (table.length && table[0].id === "table_patient_administration_history") {
			if (aData["flag"] === 'MERGE') {
				element.parents('.tt-content-datatable').find('.tt-show-merge-detail').removeClass('disabled');
			} else {
				element.parents('.tt-content-datatable').find('.tt-show-merge-detail').addClass('disabled');
			}
			defer.resolve();
		} else if (table.length && table[0].id === "table_system_events") {
			element.parents('.tt-content-datatable').find('.tt-save-file,.tt-redo-event').data('selectedId', aData[0]);
            if (aData[6] !== '') {
				element.parents('.tt-content-datatable').find('.tt-save-file').removeClass('disabled');
            } else {
				element.parents('.tt-content-datatable').find('.tt-save-file').addClass('disabled');
            }
			if (aData[4] === 'FAILED') {
				element.parents('.tt-content-datatable').find('.tt-redo-event').removeClass('disabled');
			} else {
				element.parents('.tt-content-datatable').find('.tt-redo-event').addClass('disabled');
			}
			defer.resolve();
		} else {

            if (table.length && (table[0].id === "table_roles" || table[0].id === "table_facilities")) {
                element.parents('.tt-content-datatable').find('.tt-roles-overview').removeClass('disabled');
                var url = $('#table_roles_overview').data().tableUrl;
                url = url.substr(0, url.lastIndexOf('/')) + '/' + element[0].id;
                reloadTable('#table_roles_overview', url);
                if (table[0].id === "table_roles") {
                    $('#table_roles_overview_dialog').find('.modal-title').text(trans('tripletrax.roles_overview') + ' - ' + aData[1]);
                } else if (table[0].id === "table_facilities") {
                    $('#table_roles_overview_dialog').find('.modal-title').text(trans('tripletrax.roles_overview') + ' - ' + aData[2] + ' [' + aData[1]  +']');
                }
            }

            tableSingleClickAjaxCall(element, newUrl, aPos, aData, initializeElements)
                .done(function() {
                    defer.resolve();
                });
        }
    }).promise();
}

function tableSingleClickAjaxCall(element, newUrl, aPos, aData, initializeElements) {
    return $.Deferred(function (defer) {

        ajax.ajaxCallDeferred(newUrl, 'GET', null, false)
            .done(function (data) {
                if (ajax.ajaxSucceeded(data)) {

                    // Löschen-Button aktiv setzen, wenn eine Zeile ausgewählt wurde, außer:
                    // 1. Es handelt sich um die Benutzer-Tabelle und der Benutzer 'administrator' wurde ausgewählt
                    // 2. Es handelt sich um die Einwilligungen-Tabelle (diese wird separat behandelt, da der Löschen-Button vom jeweiligen Eintrag abhängig ist)
					// 3. Es handelt sich um die Untersuchungs-Tabelle (diese wird separat behandelt, da dort einzelne Untersuchungen gesperrt sein können)
					// 4. Es handelt sich um die Patientenliste und der Patient ist gesperrt
                    // 5. Der Benutzer kein Recht für Löschen hat
                    if (!(element.parents('.tt-datatable,.tt-datatable-data').length && (element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_users" && aData.length >= 3 && aData[2] === "administrator"))
                        && !(element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_patient_agreement")
                        && !(element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_patient_examination")
						&& !(element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_patientlist" && ('locked_patient' in aData) && !utils.isUndefined(aData['locked_patient']))
                        && !element.parents('.tt-content-datatable').find('.tt-right-button-delete').hasClass('no-rights')) {
                        element.parents('.tt-content-datatable').find('.tt-delete').removeClass('disabled');
                        element.parents('.tt-content-datatable').find('.tt-delete').removeAttr('disabled');
                    } else {
                        element.parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
                        element.parents('.tt-content-datatable').find('.tt-delete').prop('disabled', 'disabled');
                    }

                    if (element.parents('.tt-content-datatable').find('.tt-selected-pos').length > 0) {
                        element.parents('.tt-content-datatable').find('.tt-selected-pos').val(aPos);
                    }

                    if (element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_patientlist") {

                        var patientData = patients.mergePatientAndIDATData(aData, data[0], data[1]);

                        var course = utils.getCourse();
                        var questionnaire = utils.getQuestionnaire();
                        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', jQuery.extend({}, patientData));
                        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data', patientData);
                        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data_is_set', false);
						course.find('.tt-doc-pane.data-loaded').removeClass('data-loaded');
						if (!utils.isUndefined(questionnaire)) {
							questionnaire.find('.tt-doc-pane.data-loaded').removeClass('data-loaded');
						}
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', []);
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data', '');
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('transfer_examination_data', null);
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('tab_transfer_data', null);
						course.find('.tt-transfer-data-button-group').addClass('hide');
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data', '');
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id', '');
						$('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_locked', null);
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').val('');
                        $('.tt-nav-content-article').find('.tt-selected-examination-date').val('');

                        $.each($('body').find('.tt-dialog-open'), function (i, button) {
							if (!$(button).hasClass('tt-create-examination')) { // "Neue Untersuchung"-Button wird separat behandelt
                            	if ($(button).hasClass('no-rights') || (('locked_patient' in aData) && !utils.isUndefined(aData['locked_patient']))) {
									$(button).addClass('disabled');
									$(button).prop('disabled', 'disabled');
                            	} else {
									$(button).removeClass('disabled');
									$(button).removeAttr('disabled');
                            	}
							}
                        });

                        $('body').find('.tt-show-agreement-list').removeClass('disabled');
                        //console.timeEnd("tabelle click 6");

                    } else if (element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_patient_examination") {

                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', jQuery.extend({}, $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data'), data[0]));
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data', data[0]);
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data_is_set', false);
                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data', '');
						if (!utils.isUndefined(data[1])) {
							$('.tt-nav-content-article').find('.tt-selected-examination-id').data('transfer_examination_data', data[1]);
						}
						if (!utils.isUndefined(data[2])) {
							$('.tt-nav-content-article').find('.tt-selected-examination-id').data('tab_transfer_data', data[2]);
						}

						// Löschen-Button nur aktiv setzen, wenn
						// 1. Die Untersuchung meiner eigenen Einrichtung gehört
						// 2. Der Benutzer das Recht zum Löschen hat
						// 3. Die Untersuchung nicht gesperrt ist
                        if ($('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id') === views.getFacilityId()
							&& !element.parents('.tt-content-datatable').find('.tt-right-button-delete').hasClass('no-rights')
							&& (utils.isUndefined(aData) || utils.isUndefined(aData.locked_patient))) {
							// Löschen-Button aktiv setzen, wenn das Recht für Löschen der ausgewählten Untersuchung vorhanden ist
							var currentModel = views.getModelId();
							if (currentModel > 0) {
                                if (currentModel + '-delete_examination-delete' in utils.GLOBALS.rights && utils.GLOBALS.rights[currentModel + '-delete_examination-delete'] == 1) {
                                    element.parents('.tt-content-datatable').find('.tt-delete').removeClass('disabled');
                                } else {
                                    element.parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
                                }
							}
                        } else {
                            element.parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
                        }

                    } else {
                        utils.setHtmlData($("#content-detail"), data, initializeElements);

                        if (element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_mails"
                            && element.parents('.tt-datatable,.tt-datatable-data')[0].getAttribute('data-table-folder') !== "draft" && aData[7] === 0) {
                            if (!$(this).parents('hidden-desktop').length) {
                                var unreadMails = parseInt($('.inbox-menu-lg').find('li.active').find('strong').text().replace('(', '').replace(')', ''));
                                if (unreadMails <= 1) {
                                    $('.inbox-menu-lg').find('li.active').find('strong').remove();
                                } else {
                                    $('.inbox-menu-lg').find('li.active').find('strong').text('(' + (unreadMails - 1) + ')');
                                }
                            }
                            var unreadMails = parseInt($('#mail_nav').find('.badge').text());
                            if (unreadMails <= 1) {
                                $('#mail_nav').find('.badge').remove();
                            } else {
                                $('#mail_nav').find('.badge').text((unreadMails - 1).toString());
                            }
                        }
                        if ($("#content-detail").find('input:text,span.select2-selection').length) {
                            $("#content-detail").find('input:text,span.select2-selection')[0].focus();
                        }
                    }
                    defer.resolve();
                } else {
                    defer.reject();
                }
            })
            .fail(function () {
                defer.reject();
            });
    }).promise();
}

function tableDoubleClick(element) {

    var aPos = element.parents('.tt-datatable,.tt-datatable-data').dataTable().fnGetPosition(element.parent()[0]);
    var aData = element.parents('.tt-datatable,.tt-datatable-data').dataTable().fnGetData(aPos);

    if (element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_patient_agreement") {

    	// bei gesperrten Patienten den Dialog nicht öffnen
    	if (!utils.isUndefined(aData.locked_patient)) {
    		return;
		}

        // Bei Anzeige einer bestehenden Datenerhebungsart alle mit Recht zum Einschreiben zur Verfügung stellen
        var data = [];
        var alreadyAddedModels = [];
		$.each($.parseJSON($('#agreements_with_register_patient_right').val()), function (h, agreement) {

			var agreementModels = agreement.data_collection_types.split('|');
			$.each(agreementModels, function (k, agreementModel) {

				$.each($.parseJSON($('#models_with_register_patient_right').val()), function (i, model) {

					// Datenerhebungsarten ermitteln, in welchen ich selbst als abhängige dokumentiert bin
					var otherDependingModels = '';
					$.each($.parseJSON($('#all_models').val()), function (j, dependingModel) {
						if (dependingModel.depending_models === '' || dependingModel.depending_models === '-1') {
							return true;
						}

						var dependingModels = dependingModel.depending_models.split('|');
						$.each(dependingModels, function (j, depModel) {
							if (depModel == model.id) {
								if (otherDependingModels !== '') {
									otherDependingModels += '|';
								}
								otherDependingModels += dependingModel.id;
							}
						});
					});

					if (agreementModel == model.id && jQuery.inArray(agreement.id, alreadyAddedModels) < 0) {
						data.push({id: agreement.id, text: agreement.description, depending_models: model.depending_models, other_depending_models: otherDependingModels, models: agreement.data_collection_types});
						alreadyAddedModels.push(agreement.id);
					}

				});
			});
        });

        var modelField = $('#table_patient_agreement_create_dialog').find('[name="agreement_type"]').parent();

        validator.reinitializeSelect2($(modelField), 'input-sm tt-select2', '', data, false);

        $('#table_patient_agreement_create_dialog').find('.tripletrax-modal-title').text(trans('tripletrax.change_agreement'));
        $('#table_patient_agreement_create_form').find('.tt-selected-id').val(aData.patient_agreement_ids);
        $('#table_patient_agreement_create_form').find('.tt-selected-end-date').val(aData.end_date);
        $('#table_patient_agreement_create_form').find('.tt-selected-agreement').val(aData.agreement);
        $('#table_patient_agreement_create_form').find('[name="agreement_type"]').val(aData.id).trigger('change.select2');
        $('#table_patient_agreement_create_form').find('[name="agreement_type"]').prop('disabled', 'disabled');
        $('#table_patient_agreement_create_form').find('[name="agreement"][value="' + aData.agreement + '"]').prop('checked', 'checked');
        $('#table_patient_agreement_create_form').find('[name="pat_id"]').val(aData.participantid);
        $('#table_patient_agreement_create_form').find('[name="begin_date"]').data('picker').setDate(utils.stringToDate(aData.begin_date));
        $('#table_patient_agreement_create_form').find('[name="end_date"]').data('picker').setDate(utils.stringToDate(aData.end_date));

        if (!utils.isUndefined($('#table_patient_agreement_create_form').find('[name="agreement_type"]').select2('val')) && $('#table_patient_agreement_create_form').find('[name="agreement_type"]').select2('val') !== '') {
            element.parents('.tt-content-datatable').find('.tt-dialog-open').click();
        }
    } else if (element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_patient_examination") {
        if ($('[href="#content-detail-course"]').length) {
            var selectDataTab = null;
            var hasRightCreateExamination = false;
            if (views.getModelId() > 0) {
                if (views.getModelId() + '-create_examination-all_rights' in utils.GLOBALS.rights && utils.GLOBALS.rights[views.getModelId() + '-create_examination-all_rights'] == 1) {
                    hasRightCreateExamination = true;
                }
            }
            if (element[0].cellIndex > 0) {
                var table = element.parents('.tt-datatable,.tt-datatable-data').DataTable();
                var idx = table.cell(element[0]).index().column;
                selectDataTab = $(table.column(idx).header()).data().columnName;
            }
            if (selectDataTab === null && aData.facility_id.toString() === views.getFacilityId().toString() && hasRightCreateExamination && utils.isUndefined(aData.locked_patient)) {
                openChangeExaminationDialog(aData);
            } else {
                selectNavigationTab($('[href="#content-detail-course"]'), selectDataTab);
            }
        }
    } else if (element.parents('.tt-datatable,.tt-datatable-data').length && element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_patientlist") {
        if ($('[href="#content-detail-master"]').length) {
            selectNavigationTab($('[href="#content-detail-master"]'), null);
        }
    }
}

function openChangeExaminationDialog(aData) {

    $('#table_patient_examination_create_dialog').find('.tripletrax-modal-title').text(trans('tripletrax.change_examination'));
    $('#table_patient_examination_create_form').find('.tt-selected-id').val(aData.id);
    $('#table_patient_examination_create_form').find('.tt-selected-id').data('examintiondate', aData.examinationdate);
    $('#table_patient_examination_create_form').find('[name="exam_date"]').data('picker').setDate(aData.examinationdate);
    $('#table_patient_examination_create_form').find('[name="exam_time"]').timepicker('setTime', utils.dateToTimepickerString(aData.examinationdate));

    var helpText = '';
    if (!utils.isUndefined($('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data')) && $('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data').length) {
        helpText = $('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data')[0].helpExaminationdate;
    }
    $('#table_patient_examination_create_form').find('#help_examinationdate_format').text(helpText);

    $('#table_patient_examination_create_dialog').modal('show');
}

function setSelectedExamination(selectExaminationInTable, examinationId) {

    var course = utils.getCourse();
    var questionnaire = utils.getQuestionnaire();
    if (selectExaminationInTable) {
        $('#table_patient_examination').DataTable().page.jumpToData(parseInt(examinationId), 0);
        utils.GLOBALS.runningTableClickRequests.push(tableSingleClick($('#table_patient_examination').find('tr[id="' + examinationId + '"]')).done(function() {
            utils.GLOBALS.runningTableClickRequests.length = 0;
			var selectDataTab = null;
            var courseTab = $('[href="#content-detail-course"]');
            var questionnaireTab = $('[href="#content-detail-questionnaires"]');
            if (questionnaireTab.length && questionnaireTab.parent().hasClass('active')) {
				if (questionnaire.find('li.active .tt-doc-tab').length) {
				    if (questionnaire.find('li.active .tt-doc-tab:not(.hide)').length) {
						selectDataTab = questionnaire.find('li.active .tt-doc-tab').attr('href').substr(1);
					}
				}
				selectNavigationTab(questionnaireTab, selectDataTab);
            } else if (courseTab.length) {
                if (course.find('li.active .tt-doc-tab').length) {
                    selectDataTab = course.find('li.active .tt-doc-tab').attr('href').substr(1);
                }
                selectNavigationTab(courseTab, selectDataTab);
            }
        }));
    } else {
        var examinationId = $('.tt-nav-content-article').find('.tt-selected-examination-id').val();

        if (examinationId !== '') {
            var examinationDate = $('.tt-nav-content-article').find('.tt-selected-examination-date').val();
            var selectedListElement = course.find('.tt-select-examination-dropdown').find('li[data-examination-id="' + examinationId + '"]');

            course.find('.tt-select-examination-dropdown').find('li').removeClass('active');
			course.find('.tt-select-examination-dropdown').find('li[data-examination-id="' + examinationId + '"]').addClass('active');
            course.find('.tt-select-examination').find('span').html(utils.getExaminationDateString(examinationDate, utils.getExaminationDateFormat()) + '&nbsp;');

			if (!utils.isUndefined(questionnaire)) {
				questionnaire.find('.tt-select-examination-dropdown').find('li').removeClass('active');
				questionnaire.find('.tt-select-examination-dropdown').find('li[data-examination-id="' + examinationId + '"]').addClass('active');
				questionnaire.find('.tt-select-examination').find('span').html(utils.getExaminationDateString(examinationDate, utils.getExaminationDateFormat()) + '&nbsp;');
			}

            if (selectedListElement.index() === 0 && course.find('.tt-select-examination-dropdown li').length > 0) {
                course.find('.tt-next-examination').attr('disabled', 'disabled');
				if (!utils.isUndefined(questionnaire)) {
					questionnaire.find('.tt-next-examination').attr('disabled', 'disabled');
				}
            } else {
                course.find('.tt-next-examination').removeAttr('disabled');
				if (!utils.isUndefined(questionnaire)) {
					questionnaire.find('.tt-next-examination').removeAttr('disabled');
				}
            }
            if (selectedListElement.index() === course.find('.tt-select-examination-dropdown li').length - 1) {
                course.find('.tt-previous-examination').attr('disabled', 'disabled');
				if (!utils.isUndefined(questionnaire)) {
					questionnaire.find('.tt-previous-examination').attr('disabled', 'disabled');
				}
            } else {
                course.find('.tt-previous-examination').removeAttr('disabled');
				if (!utils.isUndefined(questionnaire)) {
					questionnaire.find('.tt-previous-examination').removeAttr('disabled');
				}
            }

            // console.time('tt-display-restriction');
			utils.detachCourse();
			utils.getCourse().find('.tt-hide').removeClass('tt-hide');
			jQuery.each(utils.getCourse().find('.tt-display-restriction'), function (i, subelement) {
			    var restrictionArray = $(subelement).data().displayRestriction;
			    if (!utils.isUndefined(restrictionArray)) {
					$(subelement).addClass('tt-hide');
					jQuery.each(restrictionArray, function (k, restriction) {
						if (restriction[0] == null) {
							if (utils.stringToDate(examinationDate) <= utils.stringToDate(restriction[1])) {
								$(subelement).removeClass('tt-hide');
							}
						} else if (restriction[1] == null) {
							if (utils.stringToDate(examinationDate) >= utils.stringToDate(restriction[0])) {
								$(subelement).removeClass('tt-hide');
							}
						} else {
							if (utils.stringToDate(examinationDate) >= utils.stringToDate(restriction[0]) && utils.stringToDate(examinationDate) <= utils.stringToDate(restriction[1])) {
								$(subelement).removeClass('tt-hide');
							}
						}
					});
					if ($(subelement).hasClass('tt-hide')) {
						if ($(subelement).hasClass('tt-accordion-panel-body')) {
							$(subelement).parents('.tt-accordion').find('[href="#' + subelement.id + '"]').parents('.tt-accordion-panel').addClass('tt-hide');
						} else if ($(subelement).parents('.sub-control').length) {
							$(subelement).parents('.sub-control').addClass('tt-hide');
						} else {
							$(subelement).parents('[class^="tt-rightclass-"]').addClass('tt-hide');
						}
					}
				}
			});
            jQuery.each(utils.getCourse().find('.tt-tab-button-group'), function (i, tabButtonGroup) {
                if ($(tabButtonGroup).find('.tt-tab-button:not(.tt-hide)').length < 2) {
                    $(tabButtonGroup).parents('.tt-repetition-panel').addClass('tt-hide');
                }
            });
			utils.appendCourse();
			// console.timeEnd('tt-display-restriction');
        }
    }
}

function selectNavigationTab(element, selectDataTab) {

    if (element.hasClass('disabled')) {
        return false;
    }

    utils.updateGlobals('programmaticClick', true);
    element.click();
    utils.updateGlobals('programmaticClick', false);

    var tab_id = element.attr('href');

    if (tab_id === '#content-detail-master' || tab_id === '#content-detail-course' || tab_id === '#content-detail-questionnaires' || tab_id === '#content-detail-completeness') {
        if ($(tab_id).is(':empty')
            || ((tab_id === '#content-detail-master' || tab_id === '#content-detail-completeness' || tab_id === '#content-detail-questionnaires') && !$('.tt-nav-content-article').find('.tt-selected-id').data('patient_data_is_set'))
            || ((tab_id === '#content-detail-course' || tab_id === '#content-detail-completeness' || tab_id === '#content-detail-questionnaires') && !$('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data_is_set'))) {

            if ($(tab_id).is(':empty')) {
				utils.showProgressbar(7000, $(tab_id), trans('tripletrax.wait_first_patient'));

                //console.time('loadData');
                //console.time('loadData1');
                ajax.ajaxCall(element.attr('data-href'), 'GET', null, false, function (data) {
                    //console.timeEnd('loadData1');
                    // console.time('loadData2');
                    utils.ignoreFieldsNameArray = [];
                    var course = utils.getCourse();
                    var master = utils.getMaster();
                    var questionnaire = utils.getQuestionnaire();
                    var newData = $('#content-detail-patientlist').find('.tt-data-collection-type').data().dataCollection;
                    utils.setHtmlData(master, data[0], true);
                    utils.setHtmlData(course, data[1], true);
					if (!utils.isUndefined(questionnaire)) {
						utils.setHtmlData(questionnaire, data[3], true);
					}
					utils.setHtmlData($('#content-detail-completeness'), data[2], true);
                    // console.timeEnd('loadData2');
                    //console.time('loadData3');

                    // muss vor setData kommen, deswegen nicht im ajax Aufruf
                    calculateLeftNavHeight();
                    validator.setExaminationSelectionList();
                    validator.setQuestionnaireSelectionList();

					validator.reinitializeSelect2(master.find('.tt-data-collection-type').parent(), 'input-sm tt-select2 no-padding tt-data-collection-type tt-data-collection-type-additional select2-container', '', newData, false);
					utils.updateGlobals('programmaticClick', true);
                    master.find('.tt-data-collection-type').val(views.getModelId()).trigger('change.select2');
					utils.updateGlobals('programmaticClick', false);
                    validator.reinitializeSelect2(course.find('.tt-data-collection-type').parent(), 'input-sm tt-select2 no-padding tt-data-collection-type tt-data-collection-type-additional select2-container', '', newData, false);
					utils.updateGlobals('programmaticClick', true);
                    course.find('.tt-data-collection-type').val(views.getModelId()).trigger('change.select2');
					utils.updateGlobals('programmaticClick', false);
					if (!utils.isUndefined(questionnaire)) {
						validator.reinitializeSelect2(questionnaire.find('.tt-data-collection-type').parent(), 'input-sm tt-select2 no-padding tt-data-collection-type tt-data-collection-type-additional select2-container', '', newData, false);
						utils.updateGlobals('programmaticClick', true);
						questionnaire.find('.tt-data-collection-type').val(views.getModelId()).trigger('change.select2');
						utils.updateGlobals('programmaticClick', false);

						utils.detachQuestionnaire();
						patients.resetForms(utils.getQuestionnaire(), true, false);
						utils.appendQuestionnaire();
					}

					if ($('#live_completeness_check').val() !== '1') {
						$('.tt-completeness-on-save').removeClass('hide');
						$('.tt-completeness-live').addClass('hide');
					}

					utils.detachCourse();
					patients.resetForms(utils.getCourse(), true, false);
					utils.appendCourse();

					utils.detachMaster();
					patients.resetForms(utils.getMaster(), true, false);
					utils.appendMaster();
                    //console.timeEnd('loadData3');
                    // console.time('loadData4');

                    $.when.apply($, utils.GLOBALS.runningTableClickRequests).done(function () {
						setFormData(tab_id, selectDataTab);
						setCompletenessFormData();
						// console.timeEnd('loadData4');
						// console.timeEnd('loadData');
						utils.hideProgressbar();
                    });

                });
            } else {
                // console.time('loadData4');
                $.when.apply($, utils.GLOBALS.runningTableClickRequests).done(function () {
                    setFormData(tab_id, selectDataTab);
					setCompletenessFormData();
					// console.timeEnd('loadData4');
                });
            }
        } else {
            if (!utils.isUndefined($('.tt-nav-content-article').find('.tt-selected-examination-id').data('transfer_examination_data'))) {
				setFormData(tab_id, selectDataTab);
            } else {
				calculateLeftNavHeight();
				if (!utils.isUndefined(selectDataTab)) {
					$('[href="#' + selectDataTab + '"]').click();
				}
			}
        }
    } else if (tab_id === '#content-detail-reports') {
        if ($(tab_id).is(':empty')) {

            $(tab_id).html('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');

            ajax.ajaxCall(element.attr('data-href'), 'GET', null, false, function (data) {
				utils.setHtmlData($('#content-detail-reports'), data, true);

				calculateLeftNavHeight();

                $.when.apply($, utils.GLOBALS.runningTableClickRequests).done(function () {
					validator.setReportSelectionList();
					setReportsFormData();
                    if (utils.GLOBALS.openReport !== null) {
                        $('.tt-select-patient-report').val(utils.GLOBALS.openReport).trigger('change.select2');
                        utils.updateGlobals('openReport', null);
                    } else {
                        $('.tt-select-patient-report').val($('[name="default_report"]').val()).trigger('change.select2');
                    }
                    reports.setChartPage();
                });
            });
        } else {
            calculateLeftNavHeight();

            $.when.apply($, utils.GLOBALS.runningTableClickRequests).done(function () {
				validator.setReportSelectionList();
                setReportsFormData();
                if (utils.isUndefined($('.tt-select-patient-report').select2('val')) || $('.tt-select-patient-report').select2('val') === '' || utils.GLOBALS.openReport !== null) {
                    if (utils.GLOBALS.openReport !== null) {
                        $('.tt-select-patient-report').val(utils.GLOBALS.openReport).trigger('change.select2');
                        utils.updateGlobals('openReport', null);
                    } else {
                        $('.tt-select-patient-report').val($('[name="default_report"]').val()).trigger('change.select2');
                    }
                    reports.setChartPage();
                } else {
                    reports.reflowCharts();
                }
            });
        }
	}
}

function setFormData(tab_id, selectDataTab) {
    var databaseTables;
    if (!$('.tt-nav-content-article').find('.tt-selected-id').data('patient_data_is_set')) {
        if ($('.tt-nav-content-article').find('.tt-selected-id').val() !== '' && views.getModelId() > 0) {
            var data = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data');
            validator.setMasterContentVisible(true);
			utils.detachMaster();
			var master = utils.getMaster();
            var selectDataTabMaster = master.find('.tt-doc-tab:first').attr('href').substr(1);
            patients.resetForms(master, true, false);
            databaseTables = master.find('[data-database-table-name]');
			var isLocked = views.getPatientIsLocked() === 1 ? true : false;
            jQuery.each(databaseTables, function (i, table) {
                var tab = $(table).parents('.tab-pane')[0];
                if (!$(tab).hasClass('data-loaded')) {
                    patients.setData($(tab), data, true, false, false, true, true, false, false, true, isLocked);
                    views.setFormDataForAjaxCall($(tab), true, true);
                }
            });
            if (!master.find('#' + selectDataTabMaster).hasClass('data-loaded')) {
                patients.setData(master.find('#' + selectDataTabMaster), data, true, false, false, true, true, false, false, true, isLocked);
            }
            $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data_is_set', true);
            // Felder für Stammdatenübersicht und Anzeige Patiententitel
            jQuery.each($('[data-control-name]'), function (i, element) {
                jQuery.each(master.find('[name="' + $(element).data().controlName + '"]'), function (i, subelement) {
                    views.setValues($(subelement).parent(), data, false);
                });
            });

            patients.setIntegrityAndCalculations(master);
			utils.appendMaster();
            views.setValues(master.find('[data-match-field="patientname"]').parent(), data, false);
            views.setValues(master.find('[data-match-field="prename"]').parent(), data, false);
            views.setValues(master.find('[data-match-field="birth_date"]').parent(), data, false);
            views.setValues(master.find('[data-match-field="gender"]').parent(), data, false);

			// Speichern-Button bei gesperrten Patienten inaktiv setzen
			if (isLocked) {
				$('.tt-content-master .tt-save-views').attr('disabled', 'disabled');
			} else {
				$('.tt-content-master .tt-save-views').removeAttr('disabled');
			}
        } else {
            validator.setMasterContentVisible(false);
        }
    }
	var transferData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('transfer_examination_data');
	var tabArray = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('tab_transfer_data');
    if (!utils.isUndefined(transferData) || ($('.tt-nav-content-article').find('.tt-selected-examination-id').val() !== '' && !$('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data_is_set'))) {
        setSelectedExamination(false, 0);
        validator.setCourseContentVisible(true);
		validator.setQuestionnaireContentVisible(Object.keys(views.getQuestionnaires()).length > 0);
        var data = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data');
        var patientData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data');
		var courseData = null;
        if (utils.isUndefined(transferData)) {
			courseData = jQuery.extend({}, data, patientData);
        } else {
            courseData = jQuery.extend({}, data, transferData, patientData);
		}

        var isOwnFacility = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id').toString() === views.getFacilityId().toString();
        var isLocked = views.getPatientIsLocked() === 1 ? true : false;
        if (!isLocked) {
			isLocked = !utils.isUndefined($('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_locked'));
		}

		utils.detachCourse();
		var course = utils.getCourse();
		var selectTabCourse = selectDataTab;
        if (selectDataTab === null || tab_id === '#content-detail-questionnaires') {
			selectTabCourse = course.find('.tt-doc-tab:first').attr('href').substr(1);
        }
        databaseTables = course.find('[data-database-table-name],.tt-is-editable-calculation');

        var setSelectedTab = true;
        jQuery.each(databaseTables, function (i, table) {
            var tab = $(table).parents('.tab-pane')[0];
            if (!$(tab).hasClass('data-loaded')) {
                if (selectDataTab === tab.id) {
					setSelectedTab = false;
					patients.setData($(tab), courseData, true, false, false, isOwnFacility, true, false, false, true, isLocked);
                } else {
					patients.setData($(tab), courseData, true, false, false, isOwnFacility, true, false, false, true, isLocked);
                }
                views.setFormDataForAjaxCall($(tab), true, true);
            }
        });
		if (!utils.isUndefined(tabArray)) {
			$.each(tabArray, function(i, tab) {
				var tabElement = course.find('#' + tab);
				if (!$(tabElement).hasClass('data-loaded')) {
					patients.setData(tabElement, courseData, true, false, false, isOwnFacility, true, false, false, true, isLocked);
					views.setFormDataForAjaxCall(tabElement, true, true);
				}
			});
		}
        if (setSelectedTab && !course.find('#' + selectDataTab).hasClass('data-loaded')) {
			patients.setData(course.find('#' + selectDataTab), courseData, true, false, false, isOwnFacility, true, false, false, true, isLocked);
		}

        patients.setIntegrityAndCalculations(course);
		utils.appendCourse();
		if (!utils.isUndefined(selectTabCourse)) {
			if (utils.isUndefined(utils.GLOBALS.queryToShow)) {
				$('[href="#' + selectTabCourse + '"]').click();
			}
		}

		// Speichern-Button bei gesperrten Patienten bzw. Untersuchungen inaktiv setzen
		if (isLocked) {
			$('.tt-content-course .tt-save-views').attr('disabled', 'disabled');
		} else {
			$('.tt-content-course .tt-save-views').removeAttr('disabled');
		}

		var selectTabQuestionnaire = selectDataTab;
        utils.detachQuestionnaire();
        var questionnaire = utils.getQuestionnaire();
		if (!utils.isUndefined(questionnaire)) {

			var questionnaireTabs = questionnaire.find('.tt-doc-tab:not(.hide)');
			if (questionnaireTabs.length) {
				if (selectDataTab === null || tab_id === '#content-detail-course') {
					selectTabQuestionnaire = $(questionnaireTabs[0]).attr('href').substr(1);
				}

				jQuery.each(questionnaireTabs, function (i, questionnaireTab) {
					var tab = questionnaire.find('#' + $(questionnaireTab).attr('href').split('#')[1]);
					if (!$(tab).hasClass('data-loaded')) {
						patients.setData($(tab), courseData, true, false, true, isOwnFacility, true, false, false, true, isLocked);
						views.setFormDataForAjaxCall($(tab), true, true);
					}
				});
			}
			utils.appendQuestionnaire();
			if (!utils.isUndefined(selectTabQuestionnaire)) {
				if (utils.isUndefined(utils.GLOBALS.queryToShow)) {
					$('[href="#' + selectTabQuestionnaire + '"]').click();
				}
			}

			// Speichern-Button und Hinzufügen-Button bei gesperrten Patienten bzw. Untersuchungen inaktiv setzen
			if (isLocked) {
				$('.tt-content-questionnaires .tt-save-views').attr('disabled', 'disabled');
                $('.tt-content-questionnaires .tt-add-questionnaire').attr('disabled', 'disabled');
			} else {
				$('.tt-content-questionnaires .tt-save-views').removeAttr('disabled');
                $('.tt-content-questionnaires .tt-add-questionnaire').removeAttr('disabled');
			}
		}

        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_data_is_set', true);
		$('.tt-nav-content-article').find('.tt-selected-examination-id').data('transfer_examination_data', null);
    }
	if (!utils.isUndefined(tabArray)) {
		$.each(tabArray, function(i, tab) {
			$('#' + tab).find('.tt-transfer-data-button-group').removeClass('hide');
		})
	}
    if (!utils.isUndefined(selectDataTabMaster)) {
        $('[href="#' + selectDataTabMaster + '"]').click();
    }

	views.setCompleteness(null, views.getFormDataForAjaxCall(true, true, false), false, 1);

    if (!utils.isUndefined(utils.GLOBALS.queryToShow) && utils.GLOBALS.queryToShow !== '') {

        validator.goToControl(utils.GLOBALS.queryToShow, utils.GLOBALS.queryToShowTableType, utils.GLOBALS.queryToShowTableName);
    }
	if (!utils.isUndefined(utils.GLOBALS.completenessToShow) && utils.GLOBALS.completenessToShow !== '') {

		$('#content-detail-master,#content-detail-course').find('.tt-btn-missing-field .fa-edit:not(.tt-pulsate),.tt-completeness-tab-icon .fa-edit:not(.tt-pulsate),.tt-completeness-tab-icon-missing-all .fa-minus:not(.tt-pulsate)').each(function () {
			$(this).pulsate({
				color: '#DB4A67',
				glow: true,
				speed: 1000,
				pause: 1000,
				reach: 5
			});
			$(this).addClass('tt-pulsate');
		});
		$('.tt-back-to-completeness-button').parent().removeClass('hide');
		validator.goToControl(utils.GLOBALS.completenessToShow, utils.GLOBALS.completenessToShowTableType, utils.GLOBALS.completenessToShowTableName);
		utils.updateGlobals('completenessToShow', null);
		utils.updateGlobals('completenessToShowTableType', null);
		utils.updateGlobals('completenessToShowTableName', null);
	}
}

function setReportsFormData() {
    if ($('.tt-nav-content-article').find('.tt-selected-id').val() !== '' && views.getModelId() > 0) {
        validator.setReportsContentVisible(true);
    } else {
        validator.setReportsContentVisible(false);
    }
}

function setCompletenessFormData() {
	if ($('.tt-nav-content-article').find('.tt-selected-id').val() !== '' && views.getModelId() > 0 && $('[name="show_patients_incomplete_course_data"]').is(':checked')) {
		$('.tt-nav-content-article').find('.header-completeness-overview').text(trans('tripletrax.completeness_title', {'completeness': $('[name="show_patients_incomplete_course_data_year"]').select2('data')[0].text}));
		validator.setCompletenessContentVisible(true);
	} else {
		validator.setCompletenessContentVisible(false);
	}
}

function calculateLeftNavHeight() {

    if (!utils.isUndefined($('.tt-nav-content-article')) && !utils.isUndefined($('.tt-row-tab').find('.tt-nav-tab')) && $('.tt-row-tab').find('.tt-nav-tab').hasClass('tabs-left')) {
        var height = 0;
        jQuery.each($('.tab-pane.active .tt-nav-content-article'), function (i, val) {
            height += $(val).height();
        });
        var minHeight = parseInt($('.tt-row-tab').find('.tt-nav-tabs')[0].getAttribute('data-min-height'));
        if (minHeight > height) {
            height = minHeight;
        }
        $('.tt-row-tab').find('.tt-nav-tabs').height(height);
    }
}

module.exports.saveChanges = saveChanges;
module.exports.cancelViews = cancelViews;
module.exports.saveViews = saveViews;
module.exports.reloadTable = reloadTable;
module.exports.tableSingleClick = tableSingleClick;
module.exports.tableSingleClickAjaxCall = tableSingleClickAjaxCall;
module.exports.tableDoubleClick = tableDoubleClick;
module.exports.setSelectedExamination = setSelectedExamination;
module.exports.selectNavigationTab = selectNavigationTab;
module.exports.calculateLeftNavHeight = calculateLeftNavHeight;
module.exports.openChangeExaminationDialog = openChangeExaminationDialog;
